export const translation = {
  // Navigation
  nav: {
    home: 'Home',
    categories: 'Categories',
    spreadsheet: 'Spreadsheet',
    review: 'Review',
    shipping: 'Shipping',
    coupon: 'Coupon',
    warehouse: 'Warehouse',
    legit: 'Is It Legit?',
    guide: 'Guides',
    blog: 'Blog',
    about: 'About',
    contact: 'Contact',
    language: 'Language',
  },

  // Hero
  hero: {
    eyebrow: 'ALLCHINABUY SPREADSHEET RESOURCE HUB',
    h1: 'AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Guides',
    description: 'Discover useful AllChinaBuy spreadsheet resources, product finds, seller information, QC guides, shipping tips, reviews and buying resources — organized in one easy-to-search hub.',
    ctaPrimary: 'Explore AllChinaBuy Spreadsheet',
    ctaSecondary: 'Browse Product Categories',
    trustLine: 'Independent Resource • Updated Guides • Multilingual • Research-Focused',
  },

  // Search
  search: {
    h2: 'Find an AllChinaBuy Spreadsheet Resource',
    placeholder: 'Search products, sellers, spreadsheets, QC, shipping or guides...',
    button: 'Search Resources',
    popular: 'Popular:',
    tags: 'Spreadsheet • Shoes • Clothing • QC • Shipping • Review • Coupon',
  },

  // Categories
  categories: {
    h2: 'Popular AllChinaBuy Spreadsheet Categories',
    subtitle: 'Explore product categories and find what you need through the AllChinaBuy spreadsheet.',
    shoes: 'Shoes',
    hoodies: 'Hoodies/Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants/Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear/Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
    viewAll: 'View All Categories',
  },

  // Value Section
  value: {
    h2: 'Everything You Need to Research AllChinaBuy in One Place',
    description: 'Searching across scattered product links, seller lists and buying guides can be time-consuming. Our goal is to organize useful AllChinaBuy information into clear categories so you can research products, understand QC, compare shipping options and make more informed purchasing decisions.',
    cards: {
      spreadsheet: {
        title: 'Spreadsheet Resources',
        desc: 'Explore organized spreadsheet resources and product discovery guides.',
      },
      seller: {
        title: 'Seller Research',
        desc: 'Learn how to evaluate seller information and product listings.',
      },
      qc: {
        title: 'QC Guides',
        desc: 'Understand QC photos, quality factors and common issues.',
      },
      shipping: {
        title: 'Shipping Guides',
        desc: 'Learn about shipping methods, costs and delivery factors.',
      },
      reviews: {
        title: 'Reviews & Comparisons',
        desc: 'Compare important factors before making a decision.',
      },
      safety: {
        title: 'Safety Center',
        desc: 'Understand purchasing, payment, seller and shipping risks.',
      },
    },
  },

  // Review Section
  review: {
    h2: 'AllChinaBuy Review',
    description: 'Looking for an independent overview? Explore our AllChinaBuy review covering purchasing, shipping, warehouse processes, seller research and common risks.',
    cta: 'Read the AllChinaBuy Review',
  },

  // Shipping Section
  shipping: {
    h2: 'AllChinaBuy Shipping Cost & Shipping Guide',
    description: 'Shipping can vary by destination, parcel size, weight, shipping method and carrier conditions. Learn which factors can influence AllChinaBuy shipping costs and delivery times.',
    cta: 'View Shipping Guide',
  },

  // Coupon Section
  coupon: {
    h2: 'AllChinaBuy Coupon & Discount Code',
    description: 'Looking for current AllChinaBuy coupons or discount codes? Check our latest resource page and clearly distinguish verified, unverified and expired offers.',
    cta: 'Check Current Offers',
  },

  // Warehouse Section
  warehouse: {
    h2: 'AllChinaBuy Warehouse Guide',
    description: 'Learn how warehouse storage, QC, parcel consolidation and shipping preparation can affect the purchasing process.',
    cta: 'Explore Warehouse Guide',
  },

  // Legit Section
  legit: {
    h2: 'Is AllChinaBuy Legit?',
    description: 'Before using any shopping or buying-agent platform, understand seller risk, payment considerations, product quality, shipping and dispute procedures.',
    cta: 'Read the Safety & Legitimacy Guide',
  },

  // Final CTA
  finalCta: {
    h2: 'Ready to Explore the AllChinaBuy Spreadsheet?',
    description: 'Start with the spreadsheet, explore product categories, read the latest guides and learn how to research products, sellers, QC and shipping more effectively.',
    ctaPrimary: 'Explore AllChinaBuy Spreadsheet',
    ctaSecondary: 'Read Buying Guides',
  },

  // Main Site CTA
  mainSite: {
    title: 'AllChinaBuy Spreadsheet',
    button: 'Buy It Now',
    description: 'Explore the full AllChinaBuy spreadsheet on our main website for the complete product catalog.',
  },

  // Footer
  footer: {
    tagline: 'Independent AllChinaBuy Spreadsheet Resource Hub',
    resources: 'Resources',
    spreadsheet: 'Spreadsheet',
    categories: 'Categories',
    review: 'Review',
    shipping: 'Shipping',
    coupon: 'Coupon',
    warehouse: 'Warehouse',
    legit: 'Is It Legit?',
    guides: 'Guides',
    company: 'Company',
    about: 'About Us',
    contact: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    disclaimer: 'Disclaimer',
    editorial: 'Editorial Policy',
    rights: 'All rights reserved.',
    disclaimerText: 'This website provides general educational information. It does not guarantee seller quality, product authenticity, shipping outcomes, refunds or transaction results.',
  },

  // Language Names
  languages: {
    en: 'English',
    fr: 'Français',
    de: 'Deutsch',
    da: 'Dansk',
  },

  // Common
  common: {
    readMore: 'Read More',
    learnMore: 'Learn More',
    explore: 'Explore',
    backToHome: 'Back to Home',
    notFound: 'Page Not Found',
    notFoundDesc: 'The page you are looking for does not exist.',
  },

  // Meta
  meta: {
    siteName: 'AllChinaBuy Spreadsheet Hub',
    homeTitle: 'AllChinaBuy Spreadsheet 2026 — Products, Sellers & Buying Guides',
    homeDesc: 'Explore the AllChinaBuy Spreadsheet for product finds, seller resources, QC guides, shipping information, reviews, coupons and practical buying tips.',
  },
};